module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_11.jpg?v=60695727";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_11.jpg
 ** module id = 68
 ** module chunks = 1 2
 **/